// src/components/sections/ContactSection.jsx
// Contact form section with validation

import React, { useEffect } from 'react';
import { BUSINESS_SIZES } from '../../config/constants';
import { useContactForm } from '../../hooks/useContactForm';
import Input from '../common/Input';
import Select from '../common/Select';
import Textarea from '../common/Textarea';
import Button from '../common/Button';

const ContactSection = () => {
  const {
    formData,
    errors,
    isSubmitting,
    submitStatus,
    handleChange,
    handleSubmit,
    clearStatus,
  } = useContactForm();

  // Auto-hide success message after 5 seconds
  useEffect(() => {
    if (submitStatus?.success) {
      const timer = setTimeout(() => {
        clearStatus();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [submitStatus, clearStatus]);

  return (
    <section id="contact" className="relative z-10 px-6 py-20">
      <div className="max-w-4xl mx-auto">
        <div className="rainbow-border rounded-3xl bg-white p-8 md:p-12">
          <div className="text-center mb-12">
            <div className="text-6xl mb-4">🎉</div>
            <h2 className="text-4xl md:text-5xl font-bold mb-4">Ready to Grow?</h2>
              <p className="text-xl text-gray-600 dark:text-gray-300">
              Let's create something amazing together!
            </p>
          </div>

          {/* Success Message */}
          {submitStatus?.success && (
            <div className="mb-8 p-4 bg-green-100 border-2 border-green-500 rounded-2xl text-green-800 text-center font-semibold">
              ✅ {submitStatus.message}
            </div>
          )}

          {/* Error Message */}
          {submitStatus && !submitStatus.success && (
            <div className="mb-8 p-4 bg-red-100 border-2 border-red-500 rounded-2xl text-red-800 text-center font-semibold">
              ❌ {submitStatus.message}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid md:grid-cols-2 gap-6">
              <Input
                label="Your Name"
                icon="✨"
                name="name"
                type="text"
                value={formData.name}
                onChange={handleChange}
                placeholder="John Smith"
                error={errors.name}
                required
                maxLength={50}
              />
              <Input
                label="Email Address"
                icon="📧"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="john@awesome.com"
                error={errors.email}
                required
                maxLength={254}
              />
            </div>

            <Select
              label="Business Size"
              icon="📊"
              name="businessSize"
              value={formData.businessSize}
              onChange={handleChange}
              options={BUSINESS_SIZES}
              placeholder="Pick your business size"
              error={errors.businessSize}
              required
            />

            <Textarea
              label="Tell Us Your Dreams"
              icon="💭"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="I want to..."
              error={errors.message}
              rows={7}
              required
              maxLength={1000}
            />

            <Button
              type="submit"
              variant="primary"
              size="large"
              fullWidth
              disabled={isSubmitting}
              className="shimmer-button"
            >
              {isSubmitting ? 'Sending... ⏳' : 'Send It! 🚀'}
            </Button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
